import { createContext } from "react";
import io from "socket.io-client";

import { baseURL } from "../utils/api";
export const socket = io(baseURL);

export const SocketContext = createContext();
